export default "__VITE_ASSET__3TmihEqg__"